import React from 'react';
import Chip from '@mui/material/Chip';

const DiferenciaChip = ({ data }) => {
  const getChipProps = () => {
    if (data.diferencia === 'SIN DATA' || data.diferencia === 'ERROR DATA') {
      return {
        label: data.diferencia,
        color: '#FF8A65',
      };
    }

    if (data.diferencia === 'NUMERICA') {
      if (data.diferencia_numerica === null || data.diferencia_numerica === undefined) {
        return {
          label: '??',
          color: '#C489D9',
        };
      }

      const valor = Number(data.diferencia_numerica);
      return {
        label: `${valor}%`,
        color: valor === 0 ? '#BABABA' : '#C489D9',
      };
    }

    // Valor por defecto en caso de que no encaje con ninguna condición
    return {
      label: 'N/A',
      color: '#E0E0E0',
    };
  };

  const { label, color } = getChipProps();

  return (
    <Chip
      label={"Diferencia: "+label}
      size="small"
      sx={{
        backgroundColor: color,
        color: 'white',
      }}
    />
  );
};

export default DiferenciaChip;
